import React from "react";
import LegalLayout from "./LegalLayout";

const Terms = () => (
  <LegalLayout title="Terms and Conditions" lastUpdated="11 July 2026">
    <p>
      Operated by <strong>Pingme Software Design</strong> ("Ping", "we", "us"),
      registered in the United Arab Emirates. Contact:{" "}
      <a href="mailto:tariq@pingme.ae">tariq@pingme.ae</a> ·{" "}
      <a href="https://www.pingme.ae">www.pingme.ae</a>. Applies across all Ping
      products: Ping Stitch, Ping Laundry, Ping Drive, and Ping Paw.
    </p>

    <h2>1. Agreement</h2>
    <p>
      These Terms govern your access to and use of the Ping platform and its
      products (Ping Stitch, Ping Laundry, Ping Drive, Ping Paw). By using
      Ping, you agree to these Terms. If you are using Ping on behalf of a
      business, you confirm you are authorised to bind that business.
    </p>

    <h2>2. The service</h2>
    <p>
      Ping provides software that enables service businesses to send WhatsApp
      notifications and messages to their customers, manage orders and
      appointments, track payments, run marketing campaigns, and related
      functions. Features vary by product and subscription plan.
    </p>

    <h2>3. Accounts</h2>
    <p>
      You are responsible for maintaining the confidentiality of your login
      credentials and for all activity under your account. You must provide
      accurate information and keep it up to date.
    </p>

    <h2>4. Acceptable use</h2>
    <p>
      You agree not to use Ping to: send unlawful, misleading, or unsolicited
      messages; violate WhatsApp's or Meta's terms and policies; message
      individuals who have not provided the necessary consent; infringe others'
      rights; or attempt to disrupt or compromise the platform. You are
      responsible for the content of messages you send and for compliance with
      all applicable laws, including data protection and consumer protection
      laws.
    </p>

    <h2>5. Your customers' data</h2>
    <p>
      Where you upload or process data about your own customers through Ping,
      you confirm that you have the right and any necessary consent to do so,
      and you remain responsible (as the controller of that data) for your
      compliance with applicable law. Ping processes such data on your behalf
      as described in the Privacy Policy.
    </p>

    <h2>6. WhatsApp dependency</h2>
    <p>
      Ping relies on the WhatsApp Business Platform and other third-party
      providers. We are not responsible for outages, changes, pricing changes,
      restrictions, or account actions imposed by WhatsApp, Meta, or other
      third parties that are outside our control. Message delivery is not
      guaranteed and may be subject to third-party rules and limits.
    </p>

    <h2>7. Fees and payment</h2>
    <p>
      Subscription fees, trial terms, and billing cycles are as set out at
      sign-up or in your plan. Fees are exclusive of any applicable VAT unless
      stated otherwise. Unless stated otherwise, fees are charged in advance
      and are subject to the Refund Policy.
    </p>

    <h2>8. Trials</h2>
    <p>
      Where a free or discounted trial is offered, the service will convert to
      a paid subscription at the end of the trial unless cancelled beforehand,
      in accordance with the terms presented at sign-up.
    </p>

    <h2>9. Intellectual property</h2>
    <p>
      Ping and its software, branding, and content are owned by us or our
      licensors. These Terms do not grant you any ownership of the platform.
      You retain ownership of the data and content you upload.
    </p>

    <h2>10. Suspension and termination</h2>
    <p>
      We may suspend or terminate access for breach of these Terms, non-payment,
      or where required to protect the platform, other users, or comply with
      law or third-party (including WhatsApp/Meta) requirements. You may cancel
      your subscription as described in your plan.
    </p>

    <h2>11. Disclaimers</h2>
    <p>
      The service is provided "as is" and "as available". To the maximum extent
      permitted by law, we disclaim all warranties not expressly stated,
      including fitness for a particular purpose and uninterrupted availability.
    </p>

    <h2>12. Limitation of liability</h2>
    <p>
      To the maximum extent permitted by law, Ping's total liability arising
      from or related to the service is limited to the amount you paid to Ping
      in the three (3) months preceding the event giving rise to the claim. We
      are not liable for indirect, incidental, or consequential losses,
      including lost profits or lost business, or for losses arising from
      third-party (including WhatsApp/Meta) actions.
    </p>

    <h2>13. Indemnity</h2>
    <p>
      You agree to indemnify Ping against claims arising from your use of the
      platform, your messages, your customers' data, or your breach of these
      Terms or applicable law.
    </p>

    <h2>14. Governing law</h2>
    <p>
      These Terms are governed by the laws of the United Arab Emirates, and the
      courts of Dubai shall have jurisdiction, subject to any applicable free
      zone regulations relevant to our registration.
    </p>

    <h2>15. Changes</h2>
    <p>
      We may update these Terms. Continued use after changes constitutes
      acceptance. The latest version is available at{" "}
      <a href="https://www.pingme.ae">www.pingme.ae</a>.
    </p>

    <h2>16. Contact</h2>
    <p>
      <a href="mailto:tariq@pingme.ae">tariq@pingme.ae</a>.
    </p>
  </LegalLayout>
);

export default Terms;
